export const gallery = [
  {
    year: '2023',
    days: [
      {
        day: '1',
        images: [
          '2023/1nap/214r.webp',
          '2023/1nap/3odg.webp',
          '2023/1nap/3w3v.webp',
          '2023/1nap/4a7c.webp',
          '2023/1nap/4ecx.webp',
          '2023/1nap/6uh4.webp',
          '2023/1nap/71v0.webp',
          '2023/1nap/7c7j.webp',
          '2023/1nap/7mir.webp',
          '2023/1nap/894t.webp',
          '2023/1nap/9ekm.webp',
          '2023/1nap/a10b.webp',
          '2023/1nap/cob4.webp',
          '2023/1nap/cv2n.webp',
          '2023/1nap/d57h.webp',
          '2023/1nap/kfsr.webp',
          '2023/1nap/lrry.webp',
          '2023/1nap/n17x.webp',
          '2023/1nap/og6y.webp',
          '2023/1nap/ovuo.webp',
          '2023/1nap/r4t4.webp',
          '2023/1nap/r92a.webp',
          '2023/1nap/rfnp.webp',
          '2023/1nap/rv7b.webp',
          '2023/1nap/usqr.webp',
          '2023/1nap/wbhz.webp',
        ],
      },
      {
        day: '2',
        images: [
          '2023/2nap/1qln.webp',
          '2023/2nap/24yu.webp',
          '2023/2nap/26kt.webp',
          '2023/2nap/5dfv.webp',
          '2023/2nap/6ybu.webp',
          '2023/2nap/7ev9.webp',
          '2023/2nap/86pk.webp',
          '2023/2nap/8iz1.webp',
          '2023/2nap/90rn.webp',
          '2023/2nap/a0ha.webp',
          '2023/2nap/dkb7.webp',
          '2023/2nap/dxfm.webp',
          '2023/2nap/e8t0.webp',
          '2023/2nap/f0rk.webp',
          '2023/2nap/gtjc.webp',
          '2023/2nap/iujq.webp',
          '2023/2nap/iwfs.webp',
          '2023/2nap/nqbr.webp',
          '2023/2nap/ppaa.webp',
          '2023/2nap/q6rw.webp',
          '2023/2nap/qvcr.webp',
          '2023/2nap/qxuv.webp',
          '2023/2nap/rrb7.webp',
          '2023/2nap/sn2c.webp',
          '2023/2nap/tzu6.webp',
          '2023/2nap/yf1m.webp',
          '2023/2nap/ze2b.webp',
          '2023/2nap/zu5p.webp',
          '2023/2nap/zu7v.webp',
        ],
      },
      {
        day: '3',
        images: [
          '2023/3nap/0ss0.webp',
          '2023/3nap/2b71.webp',
          '2023/3nap/52qz.webp',
          '2023/3nap/6jev.webp',
          '2023/3nap/74vu.webp',
          '2023/3nap/7b7r.webp',
          '2023/3nap/87lf.webp',
          '2023/3nap/8aye.webp',
          '2023/3nap/8job.webp',
          '2023/3nap/8uc0.webp',
          '2023/3nap/95no.webp',
          '2023/3nap/b0xh.webp',
          '2023/3nap/bql2.webp',
          '2023/3nap/d5d3.webp',
          '2023/3nap/exzk.webp',
          '2023/3nap/g774.webp',
          '2023/3nap/gb2r.webp',
          '2023/3nap/gdhh.webp',
          '2023/3nap/hs4e.webp',
          '2023/3nap/i6jk.webp',
          '2023/3nap/j0sr.webp',
          '2023/3nap/l80g.webp',
          '2023/3nap/nezq.webp',
          '2023/3nap/ofya.webp',
          '2023/3nap/ohsc.webp',
          '2023/3nap/p31l.webp',
          '2023/3nap/qe9y.webp',
          '2023/3nap/ta0y.webp',
          '2023/3nap/upwb.webp',
          '2023/3nap/v7ie.webp',
          '2023/3nap/vqjr.webp',
          '2023/3nap/xwvh.webp',
          '2023/3nap/xxwv.webp',
        ],
      },
    ],
  },
  {
    year: '2024',
    days: [
      {
        day: '0',
        images: [
          '2024/0nap/20240807185259.webp',
          '2024/0nap/20240807191630.webp',
          '2024/0nap/20240807192309.webp',
          '2024/0nap/20240807194923.webp',
          '2024/0nap/20240807201028.webp',
          '2024/0nap/20240807201559.webp',
          '2024/0nap/20240807205754.webp',
          '2024/0nap/20240807210047.webp',
          '2024/0nap/20240807210620.webp',
          '2024/0nap/20240807215019.webp',
          '2024/0nap/20240807215353.webp',
          '2024/0nap/20240807215634.webp',
          '2024/0nap/20240807232722.webp',
          '2024/0nap/20240808021256.webp',
        ],
      },
      {
        day: '1',
        images: [
          '2024/1nap/20240808125656.webp',
          '2024/1nap/20240808140441.webp',
          '2024/1nap/20240808142734.webp',
          '2024/1nap/20240808150108.webp',
          '2024/1nap/20240808153425.webp',
          '2024/1nap/20240808153705.webp',
          '2024/1nap/20240808154001.webp',
          '2024/1nap/20240808154611.webp',
          '2024/1nap/20240808154710.webp',
          '2024/1nap/20240808154907.webp',
          '2024/1nap/20240808155628.webp',
          '2024/1nap/20240808155929.webp',
          '2024/1nap/20240808161804.webp',
          '2024/1nap/20240808182804.webp',
          '2024/1nap/20240808190542.webp',
          '2024/1nap/20240808191342.webp',
          '2024/1nap/20240808194127.webp',
          '2024/1nap/20240808205434.webp',
          '2024/1nap/20240808221834.webp',
          '2024/1nap/20240808223907.webp',
          '2024/1nap/20240808224134.webp',
          '2024/1nap/20240809002142.webp',
          '2024/1nap/4mdq.webp',
          '2024/1nap/83gx.webp',
          '2024/1nap/9bfb.webp',
          '2024/1nap/9wjx.webp',
          '2024/1nap/clv4.webp',
          '2024/1nap/d7qj.webp',
          '2024/1nap/e6oi.webp',
          '2024/1nap/i59m.webp',
          '2024/1nap/j48j.webp',
          '2024/1nap/k3m6.webp',
          '2024/1nap/mvnl.webp',
          '2024/1nap/nik1.webp',
          '2024/1nap/p28w.webp',
          '2024/1nap/rvkx.webp',
          '2024/1nap/zrw9.webp',
        ],
      },
      {
        day: '2',
        images: [
          '2024/2nap/20240809103311.webp',
          '2024/2nap/20240809110022.webp',
          '2024/2nap/20240809121535.webp',
          '2024/2nap/20240809145837.webp',
          '2024/2nap/20240809161831.webp',
          '2024/2nap/20240809162610.webp',
          '2024/2nap/20240809175421.webp',
          '2024/2nap/20240809192418.webp',
          '2024/2nap/20240809200825.webp',
          '2024/2nap/20240809210112.webp',
          '2024/2nap/20240809215247.webp',
          '2024/2nap/20240809230155.webp',
          '2024/2nap/20240809230635.webp',
          '2024/2nap/20240809230844.webp',
          '2024/2nap/20240809235904.webp',
          '2024/2nap/20240810010842.webp',
          '2024/2nap/5kvr.webp',
          '2024/2nap/83iq.webp',
          '2024/2nap/992m.webp',
          '2024/2nap/9fng.webp',
          '2024/2nap/bagl.webp',
          '2024/2nap/dfgd.webp',
          '2024/2nap/fmwm.webp',
          '2024/2nap/geot.webp',
          '2024/2nap/j0gf.webp',
          '2024/2nap/jd0n.webp',
          '2024/2nap/kz26.webp',
          '2024/2nap/lnca.webp',
          '2024/2nap/q8z4.webp',
          '2024/2nap/tozx.webp',
          '2024/2nap/wovj.webp',
          '2024/2nap/xr6s.webp',
          '2024/2nap/zyau.webp',
        ],
      },
      {
        day: '3',
        images: [
          '2024/3nap/20240810114526.webp',
          '2024/3nap/20240810132513.webp',
          '2024/3nap/20240810132814.webp',
          '2024/3nap/20240810134159.webp',
          '2024/3nap/20240810154304.webp',
          '2024/3nap/20240810154457.webp',
          '2024/3nap/20240810201847.webp',
          '2024/3nap/20240810203423.webp',
          '2024/3nap/20240810210724.webp',
          '2024/3nap/20240810214149.webp',
          '2024/3nap/2lfi.webp',
          '2024/3nap/31q9.webp',
          '2024/3nap/4nw2.webp',
          '2024/3nap/5ivs.webp',
          '2024/3nap/6gl7.webp',
          '2024/3nap/bzhu.webp',
          '2024/3nap/c1uu.webp',
          '2024/3nap/cbz7.webp',
          '2024/3nap/cl7c.webp',
          '2024/3nap/ftc9.webp',
          '2024/3nap/g9nx.webp',
          '2024/3nap/i18c.webp',
          '2024/3nap/kgl6.webp',
          '2024/3nap/kydv.webp',
          '2024/3nap/m3ym.webp',
          '2024/3nap/pens.webp',
          '2024/3nap/r55o.webp',
          '2024/3nap/r892.webp',
          '2024/3nap/rfwc.webp',
          '2024/3nap/wavk.webp',
          '2024/3nap/x71o.webp',
        ],
      },
    ],
  },
];
